import { render, staticRenderFns } from "./PncpBiddingCards.vue?vue&type=template&id=7046bef4&"
import script from "./PncpBiddingCards.vue?vue&type=script&lang=js&"
export * from "./PncpBiddingCards.vue?vue&type=script&lang=js&"
import style0 from "./PncpBiddingCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports